import {defPDFFooter, defPDFProperty} from "./partsOfPage"
import {getShelvingSystemPages, getSpecificationPages} from "./pages";
import {Content, TDocumentDefinitions} from "pdfmake/interfaces";
import {ShelvingInterface} from "../../store";
import {ColorsItemsInterface, SectionInterface, SectionNomenklature, SideTypeWithoutTop} from "../../store/types/store";
import {ItemI} from "../../shared";
import {GeneralSpecification} from "../MainMenu/Panels/SpecificationPanel/utils";

export interface SectionListElement extends SectionInterface {
    side: SideTypeWithoutTop
    nomenklature: SectionNomenklature
}

export const getPDFPages = (allShelving: ShelvingInterface,
                            sectionList: SectionListElement[],
                            parts: ItemI[],
                            colorsItems: ColorsItemsInterface,
                            generalSpecification?: GeneralSpecification): TDocumentDefinitions => {
    const pages = defPDFProperty;
    const showContent: Content = [];
    showContent.push(getShelvingSystemPages(allShelving))
    showContent.push(getSpecificationPages(sectionList, parts, colorsItems, generalSpecification))
    pages.content = showContent;
    pages.footer = defPDFFooter;
    pages.defaultStyle = {
        font: 'MyriadPro'
    }
    return pages as TDocumentDefinitions
}
